import { EMPLOYED_ID, PENSIONER_ID, RENTIER_ID, SELF_EMPLOYED_ID } from '../utilities/professionHelper';

const { actions: formActions } = require('react-redux-form');

const FIELDS_BY_ACCOUNT_TYPE = {
    [EMPLOYED_ID]: [
        'employed_company',
        'profession_category',
        'employed_annualIncomeAmount',
        'cno2_profession_id',
        'is_patrimony',
        'employed_hasPEP',
    ],
    [SELF_EMPLOYED_ID]: [
        'selfEmployed_company',
        'selfEmployed_annualIncomeAmount',
        'profession_cnae_answer',
        'profession_category',
        'profession_id',
    ],
    [PENSIONER_ID]: ['pensioner_annualIncomeAmount'],
    [RENTIER_ID]: ['rentier_annualIncomeAmount'],
};

export const dispatchFieldErrors = userProfile => {
    return dispatch => {
        FIELDS_BY_ACCOUNT_TYPE[userProfile.accountType].forEach(field => {
            !userProfile[field] && dispatch(formActions.setValidity(`userProfile.${field}`, { required: false }));
        });
    };
};
